import React from 'react';
import style from './SMAT.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SMAT(props) {

  //Handle list container creation
  let listArr = [
    'Inspection & Cleaning',
    'Unit Trip Tests',
    'Breaker Mechanical Checks',
    'Generator PI Testing',
    'Dummy Load Simulation Testing',
    'Generator Performance Testing',
    'Relay Calibration',
    'Meter & Instrument Calibration',
    'Breaker Electrical Checks',
    'Instrument Transformer Tests',
    'Excitation System Tune-ups',
    '"Limiter" Functionality Checks',
    'Synch System Calibration',
    'Control Sequence Checks',
    'Excitation Transformer Tests',
    'Protection Module Tests',
    '52G Generator Breaker Mechanical Checks',
    'Generator Power Factor Insulation Testing',
    'CT & PT Signal Transformer Tests',
    'Neutral Grounding Transformer Tests',
    'Voltage Regulator Dummy Load Simulation/Operational Tests',
    'Excitation System Tune-up',
    'Protection Module Tests (64F, 59E, Field OC, etc.)',
    'Limiter Proof Tests (Max Ex, Min Ex, V/Hz, etc.)',
    'Power Rectifier Bridge Tests - Including Waveform Analysis'
  ]

  let listOffset = 0
  let listContainers = []
  let containerCount = 2

  if (props.windowSize === "Mobile") {
    containerCount = 1
  }

  for (let x = 0; x < containerCount; x++) {
    let i = 0
    let listSubset = []
    while ((i < listArr.length / 2 && i + listOffset < listArr.length) || (containerCount === 1 && i < listArr.length)) {
      listSubset[i] = <li key={"listEl-" + (i + listOffset)}>{listArr[i + listOffset]}</li>
      i++
    }
    listContainers[x] = <ul key={"list-" + x} style={{msGridColumn: x + 1}}>{listSubset}</ul>
    listOffset = i
  }

  return (
    <div className={style.SMAT}>
      <Head>
        <title>System Maintenance and Testing | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a>E&#178; Engineering Services</a></Link></li>
        <span>/</span>
        <li><Link href={'/e2-engineering-services/onsite-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> Onsite Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>System Maintenance and Testing</h3>
      <p>Basler Services is the expert at providing maintenance and testing services for all of your electrical and generating system needs.</p>
      <p>A quality, periodic system maintenance program by experts from Basler Services will provide you the information and tools to achieve greater reliability of your generating system. Regular maintenance will enhance unit performance, improve in-house system troubleshooting ability and help reduce your overall system operation and maintenance costs.</p>
      <p>Basler Services will evaluate your system and develop a customized approach including recommended tasks, specifically designed for you.</p>
      <div className={style.listGrid}>
        {listContainers}
      </div>
      <p>Review the systems we service:</p>
      <div>
        <ul>
          <li><Link href={'/e2-engineering-services/turnkey-installation-upgrades/excitation-system-upgrades'}><a>Excitation & Voltage Regulator Systems</a></Link></li>
          <li><Link href={'/e2-engineering-services/turnkey-installation-upgrades/protection-systems'}><a>Generator Protection and Generator Synchronizing Systems</a></Link></li>
        </ul>
      </div>
      <p>Beyond your generating systems, Basler Services provides the following appraisal testing and maintenance support services:</p>
      <div>
        <ul>
          <li>IPP Generator Protection and Utility Interface Acceptance/Witness Testing</li>
          <li>Electrical System Demand Power Analysis</li>
          <li>Motor Control System Maintenance</li>
          <li>Tune-Ups of Line Voltage Regulators</li>
          <li>Fall of Potential Testing for Station Ground Grid Systems</li>
          <li>Tune-ups of Adjustable Frequency Drives and LCI Drive Systems</li>
          <li>Machine Tool Controls Adjustments</li>
          <li>Double Power Factor Insulation Testing</li>
        </ul>
      </div>
      <Link href={"/contact-us"}><a className={`${style.cta} ${style.primaryCta}`}>Contact Us <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
    </div>
  );
}

export default SMAT;